// TODO Need to refactor when point coordinates are obtained from inference, especially props
import { LatLngExpression } from "leaflet";
import { useMemo } from "react";
import { CircleMarker, Marker, Polygon } from "react-leaflet";

import { ACTIVE_MARKER_COLOR, LAYERS, UnitTypes } from "constant";
import {
  createSquare,
  getNorthernMostPoint,
  getPolygonCenter
} from "helpers/markerGeoHelpers";
import { useMarkerEventHandlers } from "hooks/useMarkerEventHandlers";

import MapDraggableMarkerIcon from "../../MapDraggableMarkerIcon/MapDraggableMarkerIcon";

const CIRCLE_RADIUS = 2;

const DynamicMarker = ({
  marker,
  index,
  draggableId,
  pointCoordinates,
  activeMarkerId,
  opacityByLayerList,
  mapMode,
  onAcceptDragging,
  onCancelDragging,
  onMarkerClick,
  openContextMenu,
  onMoveMarker,
  isClustering,
  onDragEnd
}) => {
  const eventHandlers = useMarkerEventHandlers({
    marker,
    draggableId,
    mapMode,
    onAcceptDragging,
    onCancelDragging,
    onMarkerClick,
    openContextMenu,
    onMoveMarker,
    onDragEnd
  });

  const position = useMemo(() => {
    if (draggableId === marker.id) return pointCoordinates;
    const coords = marker.geo_data.coordinates;
    return coords.length === 2 ? coords : getNorthernMostPoint(coords[0]);
  }, [draggableId, marker.geo_data.coordinates, marker.id, pointCoordinates]);

  const markerColor = useMemo(() => {
    return activeMarkerId === marker.id
      ? ACTIVE_MARKER_COLOR
      : marker?.additional?.classification?.color ??
          LAYERS[marker.layerAlias].color;
  }, [activeMarkerId, marker]);

  const opacity = useMemo(() => {
    return (
      opacityByLayerList.find((layer) => layer.alias === marker.layerAlias)
        ?.opacity / 100
    );
  }, [marker.layerAlias, opacityByLayerList]);

  return (
    <>
      {isClustering ? (
        <CircleMarker
          key={`marker-${marker.id}-${
            activeMarkerId === marker.id ? "active" : ""
          }`}
          color={markerColor}
          center={getPolygonCenter(marker) as LatLngExpression}
          radius={CIRCLE_RADIUS}
          eventHandlers={eventHandlers}
        />
      ) : (
        <>
          <Marker
            position={position}
            icon={MapDraggableMarkerIcon({
              marker,
              markerNumber: index + 1,
              activeMarkerId,
              draggableId,
              color: markerColor
            })}
            opacity={opacity}
            bubblingMouseEvents={true}
            draggable={draggableId === marker.id}
            eventHandlers={eventHandlers}
          />
          <Polygon
            key={`marker-${marker.id}-${
              activeMarkerId === marker.id ? "active" : ""
            }`}
            positions={
              marker?.geo_data?.type === UnitTypes.POINT
                ? createSquare(marker.geo_data.coordinates, 0.000005)
                : (marker?.geo_data
                    ?.coordinates as unknown as LatLngExpression[])
            }
            color={markerColor}
            eventHandlers={eventHandlers}
          />
        </>
      )}
    </>
  );
};

export default DynamicMarker;
